import { render, staticRenderFns } from "./component-video.vue?vue&type=template&id=62d40b5e&scoped=true&"
import script from "./component-video.vue?vue&type=script&lang=js&"
export * from "./component-video.vue?vue&type=script&lang=js&"
import style0 from "./component-video.vue?vue&type=style&index=0&id=62d40b5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d40b5e",
  null
  
)

export default component.exports